import useSelectors from "../../../store/selectors";
import {useSelector} from "react-redux";
import {useState} from "react";

const useEscena1 = () => {
    // Selectors
    const { useAuthSelectors } = useSelectors();
    const { authSelector } = useAuthSelectors();
    const auth = useSelector(authSelector);
    const [bandera, setBandera] = useState(false)

    const Animation = () => {
        setTimeout(() => {
            console.log(bandera)
            if (bandera) {
                if(document.getElementById('lente')){
                    document.getElementById('lente').style.display = 'block';
                    document.getElementById('lente1').style.display = 'block';

                    setBandera(false)
                }


            } else {
                if(document.getElementById('lente')){
                    document.getElementById('lente').style.display = 'none';
                    document.getElementById('lente1').style.display = 'none';
                    setBandera(true)
                }
            }
        }, 3000);

        setTimeout(() => {
            console.log(bandera)
            if (bandera) {
                if(document.getElementById('libro')){
                    document.getElementById('libro').style.display = 'block';

                    setBandera(false)
                }


            } else {
                if(document.getElementById('libro')){
                    document.getElementById('libro').style.display = 'none';
                    setBandera(true)
                }
            }
        }, 4000);

        setTimeout(() => {
            console.log(bandera)
            if (bandera) {
                if(document.getElementById('mapa')){
                    document.getElementById('mapa').style.display = 'block';
                    document.getElementById('mapa1').style.display = 'block';
                    document.getElementById('mapa2').style.display = 'block';
                    setBandera(false)
                }


            } else {
                if(document.getElementById('mapa')){
                    document.getElementById('mapa').style.display = 'none';
                    document.getElementById('mapa1').style.display = 'none';
                    document.getElementById('mapa2').style.display = 'none';
                    setBandera(true)
                }
            }
        }, 3000);

        setTimeout(() => {
            console.log(bandera)
            if (bandera) {
                if(document.getElementById('continuar')){
                    document.getElementById('continuar').style.display = 'block';
                    setBandera(false)
                }


            } else {
                if(document.getElementById('continuar')){
                    document.getElementById('continuar').style.display = 'none';
                    setBandera(true)
                }
            }
        }, 4000);
    }

    return {
        auth,
        Animation
    }
}

export default useEscena1;